/**
 * Whether a person is away (people in Team Work, workbench 0.89.20). AIOE's own contract; the workbench copies it into
 * `shared/schemas/availability.ts`. A cover rule `when: "away"` (teamDelegation.ts) applies while the person is away.
 *
 *   GET /people/v1/me/availability                 the caller's own (a sign-in or a desktop's token; never a node)
 *   PUT /people/v1/me/availability { away, until?, note? }   the caller's own, nobody else's
 *   GET /people/v1/availability?ids=a,b,c          people of the caller's organisation, up to 100 ids; anyone it does
 *                                                  not know, or of another organisation, reads as not away
 *
 * An `until` in the past reads as not away. Words for people: "I'm away", "Away until Friday", "Back".
 */
import { z } from "zod";
export const AVAILABILITY_NOTE_MAX = 200;
export const AVAILABILITY_IDS_MAX = 100;
export const availabilityPutSchema = z.object({
    away: z.boolean(),
    /** When they are back (ISO 8601). Past it, they read as not away. */
    until: z.string().datetime({ offset: true }).optional(),
    note: z.string().max(AVAILABILITY_NOTE_MAX).optional(),
});
/** Whether a stored availability reads as away at `now`: away, and not past its `until`. */
export function isAwayNow(a, now = new Date()) {
    if (!a?.away)
        return false;
    if (!a.until)
        return true;
    const t = Date.parse(a.until);
    return !Number.isFinite(t) || t > now.getTime();
}
//# sourceMappingURL=availability.js.map